import type { FunctionComponent } from 'react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAuth } from 'react-oidc-context';

import { config } from '../../../../config/config';
import { TitledSection } from '../../../shared/components/titled-section/titled-section';
import { createStyleHelper } from '../../../shared/utils/class-names';
import { exists } from '../../../shared/utils/filters';
import { SelfExclusionForm } from '../../components/self-exclusion-form/self-exclusion-form';
import { SelfExcludeLimitHistoryTable } from '../../components/self-exclusion-limits-history-table/self-exclusion-limit-history-table';
import {
    useGetUserSuspensionLimitsQuery,
    useSuspensionLimitsUpdatedSubscription,
} from '../../queries/suspension-limit.graphql';

import styles from './self-exclusion.module.scss';

const style = createStyleHelper(styles, 'self-exclusion');

export const SelfExclusion: FunctionComponent = () => {
    const auth = useAuth();
    const userProfileId = auth.user?.profile?.user_profile_id as string;

    const [{ data: userSelfExclusionLimitsData }, refetch] = useGetUserSuspensionLimitsQuery({
        pause: !userProfileId || !config.TENANT_ID,
        variables: {
            xTenantID: config.TENANT_ID,
            userProfileId: userProfileId,
        },
        requestPolicy: 'cache-and-network',
    });

    const [{ data }] = useSuspensionLimitsUpdatedSubscription({
        pause: !userProfileId,
        variables: {
            userProfileId: userProfileId,
        },
    });

    useEffect(() => {
        if (data?.suspensionLimitsUpdated) {
            refetch();
        }
    }, [data, refetch]);

    const userLimits = userSelfExclusionLimitsData?.userSuspensionLimits;

    return (
        <div className={style()}>
            <SelfExclusionForm />

            <TitledSection
                title={
                    <FormattedMessage
                        id="self-exclusion-limits.history.title"
                        defaultMessage="Self Exclusion Limits History"
                    />
                }
            >
                <SelfExcludeLimitHistoryTable history={userLimits?.filter(exists) ?? []} />
            </TitledSection>
        </div>
    );
};
